import React, { forwardRef } from "react";
import { TextField, InputAdornment } from "@mui/material";
import { motion } from "framer-motion";
import InputMask from "react-input-mask";

const ATextField = forwardRef(
  (
    {
      onChange,
      startIcon,
      endIcon,
      triggerAnimation = false,
      mask = null,
      maskChar = "",
      value,
      onBlur,
      ...props
    },
    ref
  ) => {
    const renderIcon = (icon, position) => {
      if (triggerAnimation === false) return null;

      const isStatic = triggerAnimation === null;
      const animationProps = {
        animate: isStatic
          ? { opacity: 1, scale: 1 }
          : { opacity: [0, 1], scale: [2, 1, 1.1, 1] },
        transition: isStatic
          ? {}
          : { duration: 0.7, repeat: 0, ease: "easeInOut" },
      };

      return (
        <motion.div {...animationProps}>
          <InputAdornment position={position}>
            <img src={icon} alt={`${position} icon`} />
          </InputAdornment>
        </motion.div>
      );
    };

    const renderTextField = (inputProps) => (
      <TextField
        {...inputProps}
        inputRef={ref}
        onChange={onChange}
        value={value}
        onBlur={onBlur}
        fullWidth
        InputProps={{
          startAdornment: startIcon && renderIcon(startIcon, "start"),
          endAdornment: endIcon && renderIcon(endIcon, "end"),
        }}
        {...props}
      />
    );

    if (mask) {
      return (
        <InputMask
          mask={mask}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          maskChar={maskChar}
        >
          {(inputProps) => renderTextField(inputProps)}
        </InputMask>
      );
    }

    return renderTextField({});
  }
);

export default ATextField;